export const contests: TableModule = {
    name: "contests",
    route: "spa.sportsManagement.contests",
    defaultOrder: {
        column: "",
        direction: "asc"
    },
    columns: [
        {
            name: "name",
            pageLink: true,
            mobile: true
        }, {
            name: 'type',
        }, {
            name: 'registration_allowed',
            width: 'max-w-45',
            breakpoint: 'md'
        }, {
            name: 'start_fee',
            width: 'max-w-45',
            breakpoint: 'lg'
        }, {
            name: 'registrations',
            width: 'max-w-45',
            breakpoint: 'md'
        }
    ],
    filters: [
        {
            name: "gameClass",
            column: "game_class_id",
            type: "select",
            reduced: 'in',
            options: () => $lara.get(
                useNuxtApp().$apiRoute('spa.sportsManagement.gameClasses.index'), {
                    params: {
                        filter: [
                            {
                                name: "sport_id",
                                column: "customFilterCurrentSportId",
                                operator: "=",
                                value: "current"
                            }
                        ]
                    }
                }
            ).then(response => response.data?.map(
                (gameClass: { id: number, name: string }) => ({
                    value: gameClass.id,
                    label: gameClass.name
                }))
            ),
            ability: ['viewAny', 'gameClasses']
        }
    ],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "contests"]
        }, {
            name: "contests.copyToSeason",
            ability: ["create", "contests"]
        }, {
            name: "contests.exportRegistrations",
        }, {
            name: "contests.exportGames",
        }
    ]
}